import { ControlConstants } from "../../control/constant/ControlConstants";
import { PanelProperties } from "../../control/properties/PanelProperties";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { ToggleButtonProperties } from "../../control/properties/ToggleButtonProperties";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { CommonStyle } from "../style/CommonStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/**
 * AbstractResponsibleGamingPanelProperties.ts
 */
export class AbstractResponsibleGamingPanelProperties extends AbstractViewProperties {
    constructor(langKey) {
        super();
        this.langKey = langKey;
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.panelProperties.equals(other.panelProperties) &&
            this.titleFieldProperties.equals(other.titleFieldProperties) &&
            this.optionProperties.equals(other.optionProperties);
    }
    setDefaultValues() {
        this.panelProperties = new PanelProperties();
        this.titleFieldProperties = new TextFieldProperties(CommonFontStyle.RESPONSIBLE_GAMING_PANEL_TITLE, null, null, ControlConstants.CENTER, ControlConstants.TOP);
        this.optionProperties = new ToggleButtonProperties(CommonStyle.RESPONSIBLE_GAMING_OPTION_BUTTON, CommonStyle.MODULE);
        this.optionProperties.textFieldProperties = new TextFieldProperties(CommonFontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_DESELECTED, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
        this.optionProperties.selectedTextFieldProperties = new TextFieldProperties(CommonFontStyle.RESPONSIBLE_GAMING_OPTION_BUTTON_SELECTED, null, null, ControlConstants.CENTER, ControlConstants.CENTER);
    }
}
//# sourceMappingURL=AbstractResponsibleGamingPanelProperties.js.map